export default __webpack_public_path__ + "static/media/icon-type.aae8898f.svg";